import { createAction } from "@/redux/helpers/action";

import { MODULE } from "./constants";

// addAlert({ id, message, variant }) queues a planner alert; dismissAlert({ id }) removes one.
export const addAlert = createAction(`${MODULE}/ADD`);
export const dismissAlert = createAction(`${MODULE}/DISMISS`);
